import {
  EValidationSeverity,
  ValidationError,
} from 'components/ui/excel-table/types';
import { TFunction } from 'i18next';
import { sumBy, isNil } from 'lodash';
import { InstallmentData } from 'components/features/binding/contract-detail/installment-details';
import dayjs from 'dayjs';
import { ContractResponseDtoContractStatusEnum } from 'libs/pinnacle-sdk';

export const validateInstallmentDetails =
  (
    installments: boolean,
    contractStatus: ContractResponseDtoContractStatusEnum
  ) =>
  (
    row: InstallmentData,
    rowIndex: number,
    allRows: InstallmentData[],
    t: TFunction
  ) => {
    const errors: ValidationError<InstallmentData>[] = [];

    if (
      !installments ||
      contractStatus === ContractResponseDtoContractStatusEnum.Cancelled ||
      contractStatus === ContractResponseDtoContractStatusEnum.NotTakenUp
    ) {
      return errors;
    }

    if (isNil(row.installmentPercent)) {
      errors.push({
        field: 'installmentPercent',
        message: t('validation.required', {
          field: t('contractDetail.installmentPercent'),
        }),
        rowIndex,
      });
    }

    if (!isNil(row.installmentPercent) && Number(row.installmentPercent) <= 0) {
      errors.push({
        field: 'installmentPercent',
        message: t('validation.min', {
          min: 0,
          field: t('contractDetail.installmentPercent'),
        }),
        rowIndex,
      });
    }

    if (isNil(row.installmentDueDate)) {
      errors.push({
        field: 'installmentDueDate',
        message: t('validation.required', {
          field: t('contractDetail.installmentDueDate'),
        }),
        rowIndex,
      });
    }

    // if total percent is not 100, return error
    const totalPercent = sumBy(allRows, (row) =>
      Number(row.installmentPercent)
    );
    if (totalPercent !== 100) {
      errors.push({
        field: 'installmentPercent',
        message: t('validation.totalPercent', {
          totalPercent,
        }),
        rowIndex,
        severity: EValidationSeverity.SOFT,
      });
    }

    return errors;
  };
